import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import SecondaryButton from '~src/shared/buttons/basicButtons/SecondaryButton.sc';
import ActionConfirmDialog from '~src/shared/dialogs/actionConfirmDialog/ActionConfirmDialog';
import { deleteCompany } from '~src/modules/companySettings/actions';
import { ApiReduxResp } from '~src/services/apiMiddleware';
import { StoreI } from '~src/rootReducer';

import { DeleteSection } from './companyDelete.sc';

interface StateProps {
  loadingDelete: boolean;
}

interface DispatchProps {
  deleteCompany(): ApiReduxResp;
}

interface OwnProps {
  onDelCompany(): void;
}

type Props = DispatchProps & OwnProps & StateProps;

const CompanyDelete: FC<Props> = (props) => {
  const [showModal, setShowModal] = useState(false);

  const toggleConfirmDelDialog = (show = false) => {
    setShowModal(show);
  };

  const showConfirmDelDialog = () => setShowModal(true);

  const onDeleteCompany = () => {
    props.deleteCompany().then(({ response }) => {
      if (response && response.status === 204) {
        props.onDelCompany();
      }
    });
  };

  const [t] = useTranslation();

  return (
    <>
      <ActionConfirmDialog
        t={t}
        titleBarKey="x.company.delete_confirmation.dialog_title"
        show={showModal}
        close
        onHide={toggleConfirmDelDialog}
        showDeletion
        confirmActionInput="delete"
        actionTitleKey="x.company.delete_confirmation.headline"
        actionContentKey="x.company.delete_confirmation.content"
        actionCall={onDeleteCompany}
        loadingAction={props.loadingDelete}
        confirmInpTitle="x.company.delete_confirmation.input_title"
        confirmInpLabel="x.company.delete_confirmation.input_label"
      />
      <DeleteSection>
        <span data-translation="x.delete.company.sub_text">{t('x.delete.company.sub_text')}</span>
        <SecondaryButton onClick={showConfirmDelDialog} type="button" $buttonColor="reddish">
          <span data-translation="x.button.delete">{t('x.button.delete')}</span>
        </SecondaryButton>
      </DeleteSection>
    </>
  );
};

const mapStateToProps = (state: StoreI): StateProps => ({
  loadingDelete: state.companySettings.loadingDelete,
});

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  deleteCompany: () => dispatch(deleteCompany()),
});

const CompanyDeleteConnected = connect(mapStateToProps, mapDispatchToProps)(CompanyDelete);

export default CompanyDeleteConnected;
